import { Pipe, PipeTransform } from '@angular/core';
import { FormlySelectOption } from '@ngx-formly/core/select';
import { get, map, toArray, zip } from 'lodash';

interface FormlySelectOptionWithMeta extends FormlySelectOption {
  meta?: {
    icon?: string;
    color?: string;
  };
}

@Pipe({
  name: 'laSelectOptionWithMeta',
  standalone: true,
})
export class SelectOptionWithMetaPipe implements PipeTransform {
  transform(
    selectOptions: FormlySelectOption[] | null,
    rawOptions: any[] | unknown[] | undefined
  ): FormlySelectOptionWithMeta[] {
    return map(selectOptions, (selectOption, i) => {
      const rawOption = get(toArray(rawOptions), `[${i}].meta`) as
        | { icon: string; color: string }
        | undefined;

      return {
        ...selectOption,
        meta: get(toArray(rawOptions), `[${i}].meta`) as
          | { icon: string; color: string }
          | undefined,
      };
    });
  }

  private _addMeta(option: FormlySelectOption) {}
}
